import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
    name: 'mxSafeHtml',
    standalone: false,
})

export class MxSafeHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: unknown): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value == null ? '' : String(value));
    }
}

